import React from "react"
import CookieConsent from "../../design_system/application/components/cookie_consent"

export default ({ source }, railsContext) => {
  return () => <CookieConsent />
}
